import { z } from "zod";
import { EventExternalGuestStatus } from "../enum.js";

export const eventExternalGuestSchema = z.object({
	id: z.uuid(),
	event_id: z.uuid(),
	email: z.email(),
	first_name: z.string().nullable(),
	last_name: z.string().nullable(),
	status: z.enum(EventExternalGuestStatus),
	created_at: z.iso.datetime(),
	updated_at: z.iso.datetime(),
});

export type EventExternalGuest = z.infer<typeof eventExternalGuestSchema>;
